import React from 'react';
import Swiper from 'react-id-swiper';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';
import ModalVideo from 'react-modal-video';
import $ from 'jquery';
import pdr1 from '../../../images/icons/teacher_resources/pdr1.png';
import pdr2 from '../../../images/icons/teacher_resources/pdr2.png';
import pdr3 from '../../../images/icons/teacher_resources/pdr3.png';
import pdr4 from '../../../images/icons/teacher_resources/pdr4.png';
// ES6 class-style
class TeacherResources extends PreLoginSessionCheck {
  

  constructor (props) {
    super(props)
    this.state = {
      isOpen: false
    }
    this.openModal = this.openModal.bind(this)
    this.goNext = this.goNext.bind(this)
    this.goPrev = this.goPrev.bind(this)
    this.swiper = null;
    this.loadDataFn=this.loadDataFn.bind(this);
    this.tabContentChange=this.tabContentChange.bind(this);
  }

  goNext() {
    if (this.swiper) this.swiper.slideNext()
  }
 
  goPrev() {
    if (this.swiper) this.swiper.slidePrev()
  }

  openModal (someValue) {
    this.setState({isOpen: true})
    this.videoId = someValue
    console.log(this.videoId);
  }

  loadDataFn(){
    $(".img-content").empty();
    $(".img-content").text("");
  }
  tabContentChange(){
    $('.img-container').on('click', function (event) {
        event.preventDefault();
        $('.img-container').removeClass('tab-active');
        $(this).addClass('tab-active');

        $('.main-content .img-content').hide();
        $($('.tab-active a').attr('href')).show();       
    });
    
    $('.resources-slider .img-container:first').trigger('click');
  }
  componentDidMount(){
        this.tabContentChange();
    }
  render() {
  	const videoId = '';
	const params = {
		slidesPerView: 4,
	 	spaceBetween: 30,
        loop: false,
        dots: true,
	 	navigation: {
	        nextEl: '.swiper-button-next',
	        prevEl: '.swiper-button-prev',
	        nextButtonCustomizedClass:'.swp-next',
	    	prevButtonCustomizedClass:'.swp-prev'	
	    },
	    breakpoints: {
		    480: {
		      slidesPerView: 1,
		      spaceBetween: 20
		    },
		    640: {
		      slidesPerView: 1,
		      spaceBetween: 30
		    },
		    768: {
		      slidesPerView: 1,
		      spaceBetween: 30
		    },
		    1024: {
		      slidesPerView: 1,
		      spaceBetween: 30
		    }
		}
    } 
  	return(
  	<section className="mtb resources-container">
      <h2>Professional Development Resources</h2>
		<div className="row">
			<div className="container resources-slider">
            <p>{this.rb("tchr.resources.p")}</p>
				<Swiper className="student-slider" slidesPerView={params.slidesPerView}  breakpoints={params.breakpoints} loop={params.loop} spaceBetween={params.spaceBetween} ref={node => {if(node) this.swiper = node.swiper} }> 					
					<div data-ga="Home - How HeyMath! really empowers Tutors and Teachers" className="swiper-slide tab-section">
						<div className="img-container">
                            <a href="#tab1" rel="nofollow">
                                <img src={pdr1} alt="How HeyMath! really empowers Tutors and Teachers"/>							
                                <h3>Thinking Mathematically</h3>
                            </a>
                        </div>
                  {(()=>{
                    if(this.isMobile() || this.isTab()){
                        return  (
                        <div className="slide-content">{this.rb("tchr.resources.tab1")}</div>
                        )
                    }
                  })()}
					</div>
                    <div data-ga="Home - How HeyMath! really empowers Tutors and Teachers" className="swiper-slide tab-section">
						<div className="img-container">
                        <a href="#tab2" rel="nofollow">
							<img src={pdr2} alt="How HeyMath! really empowers Tutors and Teachers"/>							
                            <h3>Low Threshold High Ceiling Tasks</h3>
                            </a>
                        </div>
                        
                        {(()=>{
                    if(this.isMobile() || this.isTab()){
                        return  (
                        <div className="slide-content">{this.rb("tchr.resources.tab2")}</div>
                        )
                    }
                  })()}
					</div>
                    <div data-ga="Home - How HeyMath! really empowers Tutors and Teachers" className="swiper-slide tab-section">
						<div className="img-container">
                        <a href="#tab3" rel="nofollow">
							<img src={pdr3} alt="How HeyMath! really empowers Tutors and Teachers"/>							
                            <h3>Problem Solving</h3>
                            </a>
                        </div>
                        {(()=>{
                    if(this.isMobile() || this.isTab()){
                        return  (
                        <div className="slide-content">{this.rb("tchr.resources.tab3")}</div>
                        )
                    }
                  })()}
					</div>
                    <div data-ga="Home - How HeyMath! really empowers Tutors and Teachers" className="swiper-slide tab-section">
						<div className="img-container">
                        <a href="#tab4" rel="nofollow">
							<img src={pdr4} alt="How HeyMath! really empowers Tutors and Teachers"/>							
                            <h3>CPA Methodology</h3>
                            </a>
                        </div>
                        {(()=>{
                    if(this.isMobile() || this.isTab()){
                        return  (
                          <div className="slide-content">{this.rb("tchr.resources.tab4")}
                          <ul>
                              <li>{this.rb("tchr.resources.tab4.li1")}</li>
                              <li>{this.rb("tchr.resources.tab4.li2")}</li>
                              <li>{this.rb("tchr.resources.tab4.li3")}</li>
                          </ul>
                  </div>
                        )
                    }
                  })()}

                        
					</div>
				 </Swiper> 
                {
                    (()=>{
                        if(this.isMobile() || this.isTab()){
                            return (
                                <div className="slider-btns">
                                <div className="swiper-button-prev swp-prev" onClick={this.goPrev}></div>
                                <div className="swiper-button-next swp-next" onClick={this.goNext}></div>
                                </div> 
                                
                            )
                        }
                    })()
                }
                 {
                    (()=>{
                        if(this.isBrowser()){
                            return (
                                <div className="main-content">
                                <div id="tab1" className="img-content">{this.rb("tchr.resources.tab1")}</div>
                                <div id="tab2" className="img-content">{this.rb("tchr.resources.tab2")}</div>
                                <div id="tab3" className="img-content">{this.rb("tchr.resources.tab3")}</div>
                                <div id="tab4" className="img-content">{this.rb("tchr.resources.tab4")}
                                    <ul>
                                        <li>{this.rb("tchr.resources.tab4.li1")}</li>
                                        <li>{this.rb("tchr.resources.tab4.li2")}</li>
                                        <li>{this.rb("tchr.resources.tab4.li3")}</li>
                                    </ul>
                                </div>
                            </div>
                            )
                        }
                    })()
                }
               
               
			</div> 
		</div>
	</section>
  	);
  }
}

export default TeacherResources;


// WEBPACK FOOTER //
// ./src/prelogin/src/components/TeacherResources.js